import axios from 'axios'
import wrapper from 'axios-cache-plugin'
import store from '../store/store'


const http = axios.create({
    baseURL: process.env.VUE_APP_API_URL
})

const api = wrapper(http, {
    maxCacheSize: 15,
    ttl: 60000
})

const getUrl = (url)=>{
    let token = store.state.token
    if(token) return url+'?access_token='+token
    return url
}

const getBody = (data)=>{
    return data
}

const getParams = (params) => {
    if (!params) return {}
    
    const cleanParams = {}
    
    Object.keys(params).forEach(key => {
        const value = params[key]
        if (value !== null && value !== undefined && value !== '') {
            cleanParams[key] = value
        }
    })
    
    return cleanParams
}

  export const post = async (url, body, callback) => {
      body = getBody(body)
    
      await api.post(getUrl(url), body).then(res => {
        if (res.data && res.data.error_code && 
            ['EXPIRED', 'NO_ACCESS', 'GURU_INFO_REQUIRED'].includes(res.data.error_code)) {
          callback({
            status: true, // ✅ IMPORTANT: Set status true
            data: res.data
          })
          return
        }
        
        callback({
          status: true,
          data: res.data
        })
      }).catch(err => {
        if (err.response) {
          // ✅ FIX: Only logout on actual auth errors
          if((err.response.status === 401 || err.response.status === 403)) {
            const errorData = err.response.data
            if (errorData && errorData.error_code && 
                ['EXPIRED', 'NO_ACCESS', 'GURU_INFO_REQUIRED'].includes(errorData.error_code)) {
              callback({
                status: true,
                data: errorData
              })
              return
            }
            
            store.dispatch('logout')
          } else {
            callback({
              status: false,
              message: err.response.data.message || err.response.data.error || 'Request failed',
              data: err.response.data,
            })
          }
        } else {
          callback({
            status: false,
            message: 'Connection Timed Out'
          })
        }
      })
  }

  export const put = async (url, body, callback) => {
    body = getBody(body)
  
    await api.put(getUrl(url), body).then(res => {
      if (res.data && res.data.error_code && 
          ['EXPIRED', 'NO_ACCESS', 'GURU_INFO_REQUIRED'].includes(res.data.error_code)) {
        callback({
          status: true,
          data: res.data
        })
        return
      }
      
      callback({
        status: true,
        data: res.data
      })
    }).catch(err => {
      if (err.response) {
        if((err.response.status === 401 || err.response.status === 403)) {
          const errorData = err.response.data
          if (errorData && errorData.error_code && 
              ['EXPIRED', 'NO_ACCESS', 'GURU_INFO_REQUIRED'].includes(errorData.error_code)) {
            callback({
              status: true,
              data: errorData
            })
            return
          }
          
          store.dispatch('logout')
        } else {
          callback({
            status: false,
            message: err.response.data.message || err.response.data.error || 'Request failed',
            data: err.response.data,
          })
        }
      } else {
        callback({
          status: false,
          message: 'Connection Timed Out'
        })
      }
    })
  }
  
  export const destroy = async (url, callback) => {
    await api.delete(getUrl(url)).then(res => {
      callback({
        status: true,
        data: res.data
      })
    }).catch(err => {
      if (err.response) {
        // store.commit('UPDATE_ERROR_MESSAGE', {'value': err.response.data.error})
        callback({
          status: false,
          message: err.response.data.error,
          data: err.response.data,
        })
      }
    }).catch(() => {
      callback({
        status: false,
        message: 'Connection Timed Out'
      })
    })
  }
  
  export const get = async (url, params, callback) => {
      params = getParams(params)
    
      await api.get(getUrl(url), {params}).then(res => {
        // ✅ FIX: Don't treat EXPIRED as auth failure
        if (res.data && res.data.error_code && 
            ['EXPIRED', 'NO_ACCESS', 'GURU_INFO_REQUIRED'].includes(res.data.error_code)) {
          // These are business logic errors, not auth failures
          callback({
            status: true, // ✅ IMPORTANT: Set status true so it doesn't trigger logout
            data: res.data
          })
          return
        }
        
        callback({
          status: true,
          data: res.data
        })
      }).catch(err => {
        if (err.response) {
          // ✅ FIX: Only logout on actual auth errors (401/403)
          if((err.response.status === 401 || err.response.status === 403)) {
            // Check if it's not an expected business error
            const errorData = err.response.data
            if (errorData && errorData.error_code && 
                ['EXPIRED', 'NO_ACCESS', 'GURU_INFO_REQUIRED'].includes(errorData.error_code)) {
              // This is a business logic error, not auth failure
              callback({
                status: true,
                data: errorData
              })
              return
            }
            
            // This is actual auth failure
            store.dispatch('logout')
          } else {
            callback({
              status: false,
              message: err.response.data.message || err.response.data.error || 'Request failed',
              data: err.response.data,
            })
          }
        } else {
          callback({
            status: false,
            message: 'Connection Timed Out'
          })
        }
      })
  }